module.exports = __webpack_public_path__ + "img/lCall.6fcc6066.svg";